export const LOAD_CUSTOMER_SRA_DEPARTMENTS_SUCCESS = "LOAD_CUSTOMER_SRA_DEPARTMENTS_SUCCESS";

export const CREATE_CUSTOMER_SRA_DEPARTMENT_SUCCESS = "CREATE_CUSTOMER_SRA_DEPARTMENT_SUCCESS";

export const SAVE_CUSTOMER_SRA_DEPARTMENT_SUCCESS = "SAVE_CUSTOMER_SRA_DEPARTMENT_SUCCESS";

export const DELETE_CUSTOMER_SRA_DEPARTMENT_SUCCESS = "DELETE_CUSTOMER_SRA_DEPARTMENT_SUCCESS";

export const LOAD_CUSTOMER_SRA_DEPARTMENT_DETAIL_SUCCESS = "LOAD_CUSTOMER_SRA_DEPARTMENT_DETAIL_SUCCESS";

export const CREATE_CUSTOMER_SRA_DEPARTMENT = "CREATE_CUSTOMER_SRA_DEPARTMENT";
export const SAVE_CUSTOMER_SRA_DEPARTMENT = "SAVE_CUSTOMER_SRA_DEPARTMENT";
export const DELETE_CUSTOMER_SRA_DEPARTMENT = "DELETE_CUSTOMER_SRA_DEPARTMENT";
export const LOAD_CUSTOMER_SRA_DEPARTMENT = "LOAD_CUSTOMER_SRA_DEPARTMENT";
export const LOAD_CUSTOMER_SRA_DEPARTMENT_DETAILS = "LOAD_CUSTOMER_SRA_DEPARTMENT_DETAILS";
